export default __webpack_public_path__ + "static/media/conteudo03.087cdd40.png";